import { render, staticRenderFns } from "./TableOptions.vue?vue&type=template&id=1bb09c92"
import script from "./TableOptions.vue?vue&type=script&lang=ts"
export * from "./TableOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports